/**
 * The page editors open in this tab, by document id, so Set type can get an
 * open editor's last edits to the team before it copies the page.
 */
import type { CollabSurfaceHandle } from '../collab/CollabDocumentSurface';

const handles = new Map<string, CollabSurfaceHandle>();

/** Called with the live handle on mount and null on release. */
export function trackOpenPageEditor(documentId: string, handle: CollabSurfaceHandle | null): void {
  if (handle) handles.set(documentId, handle);
  else handles.delete(documentId);
}

const FLUSH_TIMEOUT_MS = 8_000;

/** Resolves once an open editor's edits are acknowledged, or at once when none is open. */
export async function flushOpenPageEditor(documentId: string): Promise<void> {
  const handle = handles.get(documentId);
  if (!handle) return;
  const result = await handle.flush({ timeoutMs: FLUSH_TIMEOUT_MS });
  if (result.status !== 'acknowledged' && result.status !== 'not-required') {
    throw new Error('the page has edits that have not reached the team yet');
  }
}
